import { styled } from 'mz-ui-kit'
import Button from 'app/components/base/Button'

export const Body = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
  padding: '30px',
  width: '500px',
  maxWidth: '100%',
  boxSizing: 'border-box'
});

export const Text = styled('p', ({ $palette }) => ({
  margin: 0,
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  color: `${$palette('text')}`
}));

export const Actions = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '12px'
});

export const ContinueButton = styled(Button, ({ $palette }) => ({
  backgroundColor: `${$palette('primary')} !important`,
  color: '#fff !important'
}));
